const DocumentType = {
  code: true,
  name: true,
  objectTypes: true
};

export { DocumentType };